var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoArrowDownSmall = function SvgIcoArrowDownSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 6,
    fill: "none",
    viewBox: "0 0 12 6"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#EEE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m1 1 5 4 5-4"
  })));
};
export default SvgIcoArrowDownSmall;